import { Row, Divider, Title } from '@bancobarigui/barihaus';
import { Form } from 'antd';

import { UserInfoForm } from '@/components/UserInfoForm';
import { AddressFormItem } from '@/components/AddressForm';
import { SwitchCardItem } from '@/components/SwitchCardItem';
import { ProviderSelect } from '@/components/ProviderSelect';
import { useAuth } from '@/shared/hooks/useAuth';
import { RoleModuleType } from '@/shared/enums/RoleModuleType';

export function InspectorUserForm() {
  const form = Form.useFormInstance();
  const { user } = useAuth();

  const isBankUser = user?.moduleType === RoleModuleType.bank;

  return (
    <>
      {isBankUser && <ProviderSelect label="Prestadora Master" />}

      <UserInfoForm inspector={true} />

      <Title level={5}>Endereço do Inspetor</Title>

      <AddressFormItem form={form} />

      <Divider>Configurações</Divider>

      <Row>Defina os items que serão associados ao usuário.</Row>

      <SwitchCardItem
        name="allowsDemandReceiving"
        title="Permitir recebimento de demandas"
        text="Ao habilitar essa opção, o Inspetor ficará apto a receber novos direcionamentos"
      />
    </>
  );
}
